import { createFileRoute } from '@tanstack/react-router';
import { useMemo, useState } from 'react';
import { useDeleteCommiteeWorkplace } from '@/api/commitee/commitee.mutations';
import { type CommiteeWorkplace, useCommiteeWorkplaces } from '@/api/commitee/commitee.queries';
import { Title } from '@/components/Title';
import { Table } from '@/components/table/Table';
import { useTableState } from '@/components/table/useTableState';
import { getCommiteeWorkplacesColumns } from '@/features/account/workplace/columns/workplaces-columns';
import { WorkplaceDialog } from '@/features/account/workplace/WorkplaceDialog';

export const Route = createFileRoute('/gestion/entreprise/$id/lieu-de-travail')({
  component: LieuDeTravailTab,
});

function LieuDeTravailTab() {
  const { id } = Route.useParams();
  const commiteeId = Number(id);
  const { data: workplaces, isLoading, isError } = useCommiteeWorkplaces(commiteeId);
  const { mutate: deleteWorkplace } = useDeleteCommiteeWorkplace(commiteeId);
  const [workplaceToEdit, setWorkplaceToEdit] = useState<CommiteeWorkplace | null>(null);

  const columns = useMemo(
    () =>
      getCommiteeWorkplacesColumns({
        onEdit: setWorkplaceToEdit,
        onDelete: async (workplace) => {
          await deleteWorkplace(workplace.id);
        },
      }),
    [deleteWorkplace]
  );
  const tableState = useTableState('commitee-workplaces', { columns });

  return (
    <div className="flex flex-col gap-4">
      <Title>Lieux de travail{workplaces ? ` (${workplaces.length})` : ''}</Title>
      <Table
        entity={{ singular: 'lieu de travail', plural: 'lieux de travail' }}
        data={workplaces}
        columns={columns}
        tableState={tableState}
        disableHover
        isLoading={isLoading}
        isError={isError}
      />
      {workplaceToEdit && (
        <WorkplaceDialog
          key={workplaceToEdit.id}
          open
          onOpenChange={(open) => !open && setWorkplaceToEdit(null)}
          workplace={workplaceToEdit}
        />
      )}
    </div>
  );
}
